import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import {
  Rarity,
  SeasonEligibility,
} from '@sorare/core/src/__generated__/globalTypes';
import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { glossary } from '@sorare/core/src/lib/glossary';
import type { StatsRarity } from '@sorare/core/src/lib/playerSearchView';

import { SelectRarity } from 'atoms/SelectRarity';
import { TextSwitchSeasonality } from 'atoms/TextSwitchSeasonality';
import type { SeasonEligibilityOptions } from 'lib/seasonalities';

import { Block } from '../ui';

const StyledBlock = styled(Block)`
  background-color: var(--c-black);
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Grow = styled.div`
  flex-grow: 1;
`;
const rarities: StatsRarity[] = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

type Props = {
  filters: {
    seasonality: SeasonEligibilityOptions;
    rarity: StatsRarity;
  };
  setRarity: (r: StatsRarity) => void;
  setSeasonality: (s: SeasonEligibilityOptions) => void;
  onClose?: () => void;
};
export const ScoutingCenterHeader = ({
  filters: { rarity, seasonality },
  setRarity,
  setSeasonality,
  onClose,
}: Props) => {
  const { formatMessage } = useIntlContext();

  return (
    <StyledBlock>
      <Horizontal>
        {!!onClose && (
          <IconButton
            size="medium"
            onClick={onClose}
            icon={faChevronLeft}
            color="transparent"
            aria-label={formatMessage(glossary.close)}
          />
        )}
        <Grow>
          <TextSwitchSeasonality
            seasonalities={[
              SeasonEligibility.IN_SEASON,
              SeasonEligibility.CLASSIC,
            ]}
            withLabel
            seasonality={seasonality}
            setSeasonality={setSeasonality}
          />
        </Grow>
        <SelectRarity
          rarities={rarities}
          selectedRarity={rarity}
          onChange={setRarity}
        />
      </Horizontal>
    </StyledBlock>
  );
};
